import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Courses() {
  const courses = [
    { id: '001', name: 'Essential Digital Skills Qualification', icon: '💻' },
    { id: '002', name: 'BCS Level 2 Certificate in IT User Skills (ITQ)', icon: '🎓' },
    { id: '003', name: 'Functional Skills', icon: '📚' }
  ];

  return (
    <>
      <Header />
      
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #FDFCFE 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk4.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Animated Pattern Overlay */}
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          
          {/* Gradient Border Bottom */}
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '5px',
            background: 'linear-gradient(90deg, #B17ACC 0%, #7B3F9E 50%, #B17ACC 100%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 3s ease-in-out infinite'
          }}></div>
          
          <div className="container" style={{ position: 'relative', zIndex: 2, padding: '80px 20px' }}>
            <div className="row justify-content-center text-center">
              <div className="col-lg-8">
                {/* Animated Badge */}
                <div style={{
                  display: 'inline-block',
                  backgroundColor: 'rgba(123, 63, 158, 0.2)',
                  backdropFilter: 'blur(10px)',
                  padding: '12px 30px',
                  borderRadius: '50px',
                  marginBottom: '30px',
                  border: '2px solid rgba(123, 63, 158, 0.4)',
                  boxShadow: '0 4px 20px rgba(123, 63, 158, 0.2)'
                }}>
                  <span style={{ 
                    color: '#e0d9e4ff', 
                    fontSize: '0.9rem', 
                    fontWeight: '700', 
                    letterSpacing: '2px',
                    textShadow: '0 0 10px rgba(123, 63, 158, 0.5)'
                  }}>
                    📚 OUR PROGRAMS
                  </span>
                </div>
                
                <h1 style={{ 
                  fontSize: '4.5rem', 
                  fontWeight: '800',
                  color: 'white',
                  marginBottom: '30px',
                  lineHeight: '1.1',
                  letterSpacing: '-2px',
                  textShadow: '0 4px 30px rgba(0,0,0,0.5), 0 0 60px rgba(123, 63, 158, 0.2)'
                }}>
                  Our Courses
                </h1>
                
                {/* Decorative Line */}
                <div style={{
                  width: '150px',
                  height: '6px',
                  background: 'linear-gradient(90deg, transparent, #B17ACC, transparent)',
                  margin: '0 auto 35px',
                  borderRadius: '10px',
                  boxShadow: '0 0 20px rgba(123, 63, 158, 0.5)'
                }}></div>
                
                <p style={{
                  fontSize: '1.4rem',
                  color: 'rgba(255,255,255,0.95)',
                  maxWidth: '700px',
                  margin: '0 auto',
                  lineHeight: '1.8',
                  textShadow: '0 2px 15px rgba(0,0,0,0.3)',
                  fontWeight: '300'
                }}>
                  Discover our range of professional development courses
                </p>
              </div>
            </div>
          </div>
          
          <style>{`
            @keyframes float {
              0%, 100% { transform: translateY(0px); }
              50% { transform: translateY(-20px); }
            }
            @keyframes shimmer {
              0% { background-position: 200% 0; }
              100% { background-position: -200% 0; }
            }
          `}</style>
        </section>

        <section id="courses" className="courses section" style={{ padding: '80px 0' }}>
          <div className="container" data-aos="fade-up">
            {/* Introduction */}
            <div className="row justify-content-center mb-5">
              <div className="col-lg-10">
                <div className="text-center mb-5 p-4 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0',
                  position: 'relative',
                  overflow: 'hidden'
                }} data-aos="fade-up" data-aos-delay="50">
                  <div style={{
                    position: 'absolute',
                    top: '-50px',
                    left: '-50px',
                    width: '150px',
                    height: '150px',
                    background: 'linear-gradient(135deg, #7B3F9E 0%, #6B2F8E 100%)',
                    borderRadius: '50%',
                    opacity: 0.05
                  }}></div>
                  
                  <div style={{ position: 'relative', zIndex: 2 }}>
                    <div style={{
                      width: '80px',
                      height: '80px',
                      backgroundColor: '#F5EBFA',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      margin: '0 auto 20px',
                      border: '3px solid #7B3F9E',
                      fontSize: '2rem'
                    }}>
                      📖
                    </div>
                    <h2 style={{ 
                      color: '#7B3F9E', 
                      fontSize: '1.8rem', 
                      fontWeight: '700', 
                      marginBottom: '15px',
                      letterSpacing: '-0.5px'
                    }}>
                      Available Courses
                    </h2>
                    <p style={{ 
                      color: '#475569', 
                      fontSize: '1.05rem', 
                      lineHeight: '1.8', 
                      marginBottom: '0',
                      maxWidth: '600px',
                      margin: '0 auto'
                    }}>
                      Explore our professionally accredited courses designed to enhance your skills
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Courses Cards */}
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  {courses.map((course, index) => (
                    <div 
                      key={course.id}
                      data-aos="fade-up" 
                      data-aos-delay={100 + (index * 50)}
                      className="shadow"
                      style={{
                        backgroundColor: '#fff',
                        borderRadius: '20px',
                        padding: '30px',
                        border: '2px solid #e2e8f0',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.transform = 'translateY(-5px)';
                        e.currentTarget.style.borderColor = '#7B3F9E';
                        e.currentTarget.style.boxShadow = '0 12px 30px rgba(123, 63, 158, 0.15)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.borderColor = '#e2e8f0';
                        e.currentTarget.style.boxShadow = '';
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '25px' }}>
                        {/* Course Icon */}
                        <div style={{
                          minWidth: '80px',
                          height: '80px',
                          backgroundColor: '#F5EBFA',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '3px solid #7B3F9E',
                          fontSize: '2.5rem',
                          flexShrink: 0
                        }}>
                          {course.icon}
                        </div>
                        
                        {/* Course Details */}
                        <div style={{ flex: 1 }}>
                          <div style={{
                            display: 'inline-block',
                            backgroundColor: '#F5EBFA',
                            color: '#7B3F9E',
                            padding: '5px 15px',
                            borderRadius: '20px',
                            fontSize: '0.85rem',
                            fontWeight: '600',
                            marginBottom: '12px',
                            border: '1px solid #D4BFE3'
                          }}>
                            Course ID: {course.id}
                          </div>
                          <h3 style={{
                            fontSize: '1.4rem',
                            fontWeight: '700',
                            color: '#1e293b',
                            marginBottom: '10px',
                            letterSpacing: '-0.3px'
                          }}>
                            {course.name}
                          </h3>
                        </div>
                        {/* Arrow Icon */}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default Courses;